// @flow
import { compose, prop } from "ramda"
import type { Selector } from "common/redux/types"
import type { AppConfig, Activity, Location, ProductGroup, Theme } from "./types"
import type { AppState } from "./reducer"

const base: Selector<AppState> = prop("app")

export const selectAppConfig: Selector<?AppConfig> = compose(
  prop("appConfig"),
  base,
)

export const selectTheme: Selector<?Theme> = compose(
  prop("theme"),
  base,
)

export const selectActivity: Selector<?Activity> = compose(
  prop("activity"),
  base,
)

export const selectAllProductGroups: Selector<?ProductGroup[]> = compose(
  prop("allProductGroups"),
  base,
)

export const selectProductGroups: Selector<?ProductGroup[]> = compose(
  prop("productGroups"),
  base,
)

export const selectGeolocation: Selector<?(Location[])> = compose(
  prop("geolocation"),
  base,
)

export const selectGDPRHidden: Selector<?boolean> = compose(
  prop("GDPRHidden"),
  base,
)

export const selectRedirectCallback: Selector<?Function> = compose(
  prop("redirectCallback"),
  base,
)



// WEBPACK FOOTER //
// ./src/data/app/selectors.js